export interface Note {
  author: string,
  role: string,
  date?: string,
  text: string,
}

export enum AppointmentAvailability {
  MORNING = 'MORNING',
  LUNCH = 'LUNCH',
  AFTERNOON = 'AFTERNOON',
  EVENING = 'EVENING',
}

export interface Intent {
  id: string,
  propertyId: number,
  source: string,
  status: string,
  notes: Note[],
  appointmentAvailabilities: AppointmentAvailability[],
}
